<template>
    <div id="home-promo"></div>
</template>
<script>
export default {

}
</script>
<style scoped>
    #home-promo {
        width: 100%;
        height: 450px;
        background: url("~@/assets/images/home-banner.png") no-repeat center;
        background-size: cover;
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.15);
        margin-top: 40px;
    }

    @media (max-width: 1650px) {
        #home-promo {
            height: 400px;
        }
    }

    @media (max-width: 1450px) {
        #home-promo {
            height: 350px;
        }
    }

    @media (max-width: 1300px) {
        #home-promo {
            height: 300px;
        }
    }

    @media (max-width: 1200px) {
        #home-promo {
            height: 250px;
        }
    }

    @media (max-width: 991px) {
        #home-promo {
            display: none;
        }
    }
</style>
